// extracted by mini-css-extract-plugin
module.exports = {"root":"FeatureButton-root-63483568ac164c6de958cf7e75309e93","invert":"FeatureButton-invert-46ff98c03bbe49ddd248d07b647e4493"};